
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Copy, Check, Award } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';

interface ReferralCodeDisplayProps {
  referralCode: string;
}

const ReferralCodeDisplay: React.FC<ReferralCodeDisplayProps> = ({ referralCode }) => {
  const { toast } = useToast();
  const [copied, setCopied] = useState(false);
  
  const copyToClipboard = () => {
    navigator.clipboard.writeText(referralCode);
    setCopied(true);
    
    toast({
      title: "Copied!",
      description: "Referral code copied to clipboard",
    });
    
    setTimeout(() => setCopied(false), 2000);
  };
  
  return (
    <Card className="bg-gradient-to-r from-blue-50 to-indigo-50 shadow-md mb-2 overflow-hidden hover:shadow-lg transition-all duration-300">
      <CardHeader className="pb-2 flex flex-row items-center justify-between">
        <div className="flex items-center gap-2">
          <Award className="h-5 w-5 text-amber-500" />
          <CardTitle className="text-md font-semibold">YOUR UNIQUE REFERRAL CODE</CardTitle>
        </div>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-center">
          <div className="text-2xl font-semibold tracking-widest text-center w-full text-blue-600 my-1 p-2 bg-white/50 rounded-md">
            {referralCode}
          </div>
          <Button
            onClick={copyToClipboard}
            variant="subtle"
            size="sm"
            className="ml-2 transition-all duration-300 hover:bg-blue-600 hover:text-white"
          >
            {copied ? (
              <Check className="h-5 w-5 text-green-600" />
            ) : (
              <Copy className="h-5 w-5" />
            )}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default ReferralCodeDisplay;
